
import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Directive({
  selector: '[sdTablet]'
})
export class TabletDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    deviceService: DeviceDetectorService,
  ) {
    if (deviceService.isTablet()) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}
